import React, { useState, useMemo, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import { pageStatusChange, getProperty } from "../../redux/property/PropertySlice";
import PropertyDetailsModel from "./latestProperty/PropertyDetailsModel";
import LatestPropertyCard from "./latestProperty/LatestPropertyCard";
import "./LatestPropertiesNew.css";

/* Vector Icons for Filter Bar */
const GridIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
  </svg>
);

const TagIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <circle cx="7" cy="7" r="1.2" fill="currentColor" />
  </svg>
);

const HomeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 20.5v-11z" />
    <path d="M9 22V12h6v10" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#0f233a">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
  </svg>
);

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.5" y2="16.5" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const LOCATIONS = [
  "Hyderabad",
  "All Locations",
  "Kokapet",
  "Injapur",
  "Gachibowli",
  "Madhapur",
  "Kondapur",
  "Banjara Hills",
  "Jubilee Hills",
  "Hitec City",
  "Tellapur",
  "Nallagandla",
];

// Fallback showcase properties so the section is NEVER empty while loading or offline
const FALLBACK_SHOWCASE_PROPERTIES = [
  {
    propertyID: "fallback-sonthalia-1",
    apartment: "Fortune Sonthalia Sky Villas",
    category: "Sell",
    subCategory: "Flat/Apartment",
    superCategory: "Residential",
    visiblePrice: "9.2 cr",
    locality: "Kokapet",
    city: "Hyderabad",
    noofBedrooms: 4,
    noofBathrooms: 4,
    carpetArea: 4433,
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: ["https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80"],
    unicProperty: "This 4 BHK Flat/apartment is available for Sell in Fortune sonthalia sky villas kokapet, Hyderabad. Constructed on a Carpet Area of 4433 sq.ft., the...",
  },
  {
    propertyID: "fallback-krishna-2",
    apartment: "Trusted Walls Krishna Meridian",
    category: "Sell",
    subCategory: "Flat/Apartment",
    superCategory: "Residential",
    visiblePrice: "65.0 lac",
    locality: "Injapur",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 2,
    carpetArea: 1189,
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Owner",
    DeskImg: ["https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1200&q=80"],
    unicProperty: "This 3 BHK Flat/apartment is available for Sell in Trusted walls krishna meridian, one of the most prominent projects for Flat/apartment in Trus...",
  },
  {
    propertyID: "fallback-cybercity-3",
    apartment: "Dlf Cybercity",
    category: "Lease",
    subCategory: "Hospitality",
    superCategory: "Commercial",
    visiblePrice: "22.0 lac",
    locality: "Gachibowli",
    city: "Hyderabad",
    noofBedrooms: 50,
    noofBathrooms: 50,
    carpetArea: 18000,
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Owner",
    DeskImg: ["https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80"],
    unicProperty: "This Hospitality is available for Lease in dlf cybercity, one of the most prominent projects for Hospitality in dlf cybercity is available for Lease ...",
  },
  {
    propertyID: "fallback-bhooja-4",
    apartment: "My Home Bhooja",
    category: "Sell",
    subCategory: "Flat/Apartment",
    superCategory: "Residential",
    visiblePrice: "4.8 cr",
    locality: "Hitec City",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: 2680,
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: ["https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80"],
    unicProperty: "This 3 BHK Luxury Apartment is available for Sell in My Home Bhooja, Hitec City, Hyderabad. Premium amenities with 2680 sq.ft. carpet area.",
  },
];

const LatestProperties = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { propertyAll = [], sellProperty = [], rentProperty = [], pageStatus, isLoading } = useSelector(
    (store) => store.Property
  );
  const { isAuth, loginData } = useSelector((store) => store.Athentication);

  // Filters & Search state: DEFAULT ALWAYS to 0 ("All Categories")
  const [activeTab, setActiveTab] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState("Hyderabad");
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(12);

  // Modal State
  const [modal, setModal] = useState(false);
  const [singleProperty, setSingleProperty] = useState(null);
  const [actionType, setActionType] = useState("contact");

  const locationDropdownRef = useRef(null);

  // On initial mount: ALWAYS ensure tab 0 is active and properties are loaded
  useEffect(() => {
    setActiveTab(0);
    dispatch(pageStatusChange(0));
    if (!propertyAll || propertyAll.length === 0) {
      dispatch(getProperty());
    }
  }, [dispatch]);

  // Close location menu on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (locationDropdownRef.current && !locationDropdownRef.current.contains(e.target)) {
        setIsLocationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleTabChange = (index) => {
    setActiveTab(index);
    dispatch(pageStatusChange(index));
    setVisibleCount(12);
  };

  const handleActionClick = (e, property, actionType = "contact") => {
    if (e && e.preventDefault) e.preventDefault();

    if (isAuth) {
      if (loginData && loginData.creadits >= 1) {
        setSingleProperty(property);
        setActionType(actionType || "contact");
        setModal(true);
      } else {
        navigate("/dashboard");
        dispatch(pageStatusChange(9));
      }
    } else {
      toast.success("Please log in to access this content.", {
        position: "top-center",
        autoClose: 1500,
        className: "custom_toast",
      });
    }
  };

  // Helper to check if property has image
  const hasImage = (p) => {
    if (!p) return false;
    if (p.DeskImg && Array.isArray(p.DeskImg) && p.DeskImg.length > 0 && p.DeskImg[0]) return true;
    if (p.photos && Array.isArray(p.photos) && p.photos.length > 0 && p.photos[0]) return true;
    if (p.images && Array.isArray(p.images) && p.images.length > 0 && p.images[0]) return true;
    if (p.mobileimage && Array.isArray(p.mobileimage) && p.mobileimage.length > 0 && p.mobileimage[0]) return true;
    if (p.thumbnail) return true;
    return false;
  };

  // Filter and sort properties to ALWAYS default to All Categories with showcase items in Row 1:
  // 1. Fortune Sonthalia Sky Villas
  // 2. Trusted Walls Krishna Meridian
  // 3. Dlf Cybercity
  const filteredAndSortedProperties = useMemo(() => {
    let sourceList = [];

    if (activeTab === 1) {
      // For Sale
      const saleItems = (sellProperty && sellProperty.length > 0)
        ? sellProperty
        : (propertyAll || []).filter((p) => {
            const cat = (p.category || "").toLowerCase();
            return cat === "sell" || cat === "sale";
          });
      sourceList = saleItems.length > 0 ? saleItems : (propertyAll || []);
    } else if (activeTab === 2) {
      // For Rent
      const rentItems = (rentProperty && rentProperty.length > 0)
        ? rentProperty
        : (propertyAll || []).filter((p) => {
            const cat = (p.category || "").toLowerCase();
            return cat === "rent" || cat === "lease" || cat === "pg";
          });
      sourceList = rentItems.length > 0 ? rentItems : (propertyAll || []);
    } else {
      // Default: All Categories
      sourceList = propertyAll && propertyAll.length > 0 ? propertyAll : [];
    }

    // If sourceList is still empty, load from cache
    if (!sourceList || sourceList.length === 0) {
      try {
        const cached = localStorage.getItem("cached_propertyAll") || sessionStorage.getItem("cached_propertyAll");
        if (cached) {
          const parsed = JSON.parse(cached);
          if (Array.isArray(parsed) && parsed.length > 0) {
            sourceList = parsed;
          }
        }
      } catch (e) {}
    }

    // If still empty (e.g., initial network loading or offline), ensure never empty with fallback showcase
    if (!sourceList || sourceList.length === 0) {
      sourceList = FALLBACK_SHOWCASE_PROPERTIES;
    }

    let filtered = [...sourceList];

    // Filter by location if selected and not default "Hyderabad" or "All Locations"
    if (selectedLocation && selectedLocation !== "All Locations" && selectedLocation !== "Hyderabad") {
      const locKey = selectedLocation.toLowerCase();
      const locFiltered = filtered.filter((p) => {
        const locality = (p.locality || "").toLowerCase();
        const city = (p.city || "").toLowerCase();
        const apt = (p.apartment || p.apartmentName || "").toLowerCase();
        return locality.includes(locKey) || city.includes(locKey) || apt.includes(locKey);
      });
      if (locFiltered.length > 0) {
        filtered = locFiltered;
      }
    }

    // Filter by search query
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase().trim();
      const searchFiltered = filtered.filter((p) => {
        const apt = (p.apartment || p.apartmentName || "").toLowerCase();
        const loc = (p.locality || "").toLowerCase();
        const city = (p.city || "").toLowerCase();
        const sub = (p.subCategory || "").toLowerCase();
        const desc = (p.unicProperty || "").toLowerCase();
        return (
          apt.includes(q) ||
          loc.includes(q) ||
          city.includes(q) ||
          sub.includes(q) ||
          desc.includes(q)
        );
      });
      if (searchFiltered.length > 0) {
        filtered = searchFiltered;
      }
    }

    // Showcase prioritization score for Row 1
    const getShowcaseScore = (p) => {
      const text = `${p.apartment || p.apartmentName || ""} ${p.locality || ""}`.toLowerCase();
      if (text.includes("sonthalia")) return 1;
      if (text.includes("krishna meridian") || text.includes("trusted walls")) return 2;
      if (text.includes("dlf cybercity") || text.includes("cybercity")) return 3;
      return 100;
    };

    return filtered.sort((a, b) => {
      const scoreA = getShowcaseScore(a);
      const scoreB = getShowcaseScore(b);
      if (scoreA !== scoreB) return scoreA - scoreB;

      const aImg = hasImage(a);
      const bImg = hasImage(b);
      if (aImg && !bImg) return -1;
      if (!aImg && bImg) return 1;
      return 0;
    });
  }, [propertyAll, sellProperty, rentProperty, activeTab, selectedLocation, searchQuery]);

  const visibleProperties = filteredAndSortedProperties.slice(0, visibleCount);

  return (
    <section className="lp-section-container">
      <div className="lp-inner-container">
        {/* Section Header */}
        <div className="lp-header-wrap">
          {/* Header Left: Titles */}
          <div className="lp-header-left">
         
            <h2 className="lp-main-title">
              <span className="lp-title-dark">Latest </span>
              <span className="lp-title-gold">Properties</span>
            </h2>
            <p className="lp-sub-desc">
              Discover the best residential, commercial and rental properties in Hyderabad.
            </p>
          </div>

          {/* Header Right: Filter & Search Controls */}
          <div className="lp-header-right">
            {/* Row 1: Category Tabs - All Categories is active by default */}
            <div className="lp-tabs-pill-group">
              <button
                type="button"
                className={`lp-tab-pill-btn ${activeTab === 0 ? "active" : ""}`}
                onClick={() => handleTabChange(0)}
              >
                <span className="lp-tab-icon"><GridIcon /></span>
                <span>All Categories</span>
              </button>

              <button
                type="button"
                className={`lp-tab-pill-btn ${activeTab === 1 ? "active" : ""}`}
                onClick={() => handleTabChange(1)}
              >
                <span className="lp-tab-icon"><TagIcon /></span>
                <span>For Sale</span>
              </button>

              <button
                type="button"
                className={`lp-tab-pill-btn ${activeTab === 2 ? "active" : ""}`}
                onClick={() => handleTabChange(2)}
              >
                <span className="lp-tab-icon"><HomeIcon /></span>
                <span>For Rent</span>
              </button>
            </div>

            {/* Row 2: Location Dropdown & Search Input */}
            <div className="lp-sub-filters-row">
              {/* Location Selector Pill */}
              <div className="lp-location-dropdown-wrap" ref={locationDropdownRef}>
                <button
                  type="button"
                  className="lp-location-btn"
                  onClick={() => setIsLocationOpen(!isLocationOpen)}
                >
                  <span className="lp-location-pin"><MapPinIcon /></span>
                  <span>{selectedLocation}</span>
                  <span
                    className="lp-location-arrow"
                    style={{ transform: isLocationOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                  >
                    <ChevronDownIcon />
                  </span>
                </button>

                {isLocationOpen && (
                  <div className="lp-location-menu">
                    {LOCATIONS.map((loc) => (
                      <div
                        key={loc}
                        className={`lp-location-item ${selectedLocation === loc ? "selected" : ""}`}
                        onClick={() => {
                          setSelectedLocation(loc);
                          setIsLocationOpen(false);
                          setVisibleCount(12);
                        }}
                      >
                        {loc}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Search Input Pill */}
              <div className="lp-search-pill">
                <span className="lp-search-icon"><SearchIcon /></span>
                <input
                  type="text"
                  placeholder="Search properties..."
                  className="lp-search-input"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setVisibleCount(12);
                  }}
                />
                {searchQuery && (
                  <button
                    type="button"
                    className="lp-search-clear"
                    onClick={() => setSearchQuery("")}
                    title="Clear search"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Loading Spinner only if no properties are ready yet */}
        {isLoading && visibleProperties.length === 0 && (
          <div style={{ textAlign: "center", width: "100%", padding: "50px 0" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading properties...</span>
            </div>
          </div>
        )}

        {/* Property Grid: ALWAYS rendered with properties, NEVER empty */}
        <div className="lp-properties-grid">
          {visibleProperties.map((property, index) => (
            <LatestPropertyCard
              key={property.propertyID || property._id || `prop-${index}`}
              property={property}
              onActionClick={handleActionClick}
            />
          ))}
        </div>

        {/* Load More Button with Left/Right Horizontal Lines & Shimmer */}
        {filteredAndSortedProperties.length > visibleCount && (
          <div className="lp-load-more-wrap">
            <span className="lp-load-more-line lp-line-left" />
            <button
              type="button"
              className="lp-load-more-btn"
              onClick={() => setVisibleCount((prev) => prev + 12)}
            >
              <span className="lp-btn-shimmer" />
              <span className="lp-load-more-btn-text">
                Load More Properties ({filteredAndSortedProperties.length - visibleCount} remaining)
              </span>
            </button>
            <span className="lp-load-more-line lp-line-right" />
          </div>
        )}
      </div>

      {/* Details & Contact Modal */}
      {modal && singleProperty && (
        <Modal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          className="modalmainnew"
        >
          <div className="model-wrappernew">
            {/* ModalHeader omitted to prevent duplicate X button */}
            <ModalBody style={{ padding: 0 }}>
              <PropertyDetailsModel
                closePropdet={() => setModal(false)}
                propertyprop={singleProperty}
                actionType={actionType}
                changeView={() => {}}
              />
            </ModalBody>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default LatestProperties;
